module.exports = __webpack_public_path__ + "img/mysql_percona.350c802f.svg";